import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD}`

const getOvAbiertasV2 = (query) => http.get(`${api}/operacion/ov-abiertas-v2`, { params: { ...query } })

export {
  getOvAbiertasV2
}
